import { render, staticRenderFns } from "./ProductComponent.vue?vue&type=template&id=4a00dd9b&scoped=true"
import script from "./ProductComponent.vue?vue&type=script&lang=js"
export * from "./ProductComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductComponent.vue?vue&type=style&index=0&id=4a00dd9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00dd9b",
  null
  
)

export default component.exports